import { inject, Injectable } from '@angular/core';
import { PreferencesService } from '@shared/services/preferences.service';

const TOKEN_KEY = 'auth.token';
const ONBOARDING_KEY = 'app.onboarding';
const LOCALE_KEY = 'app.locale';
const FCM_TOKEN_KEY = 'push.fcm_token';
const PUSH_NOTIFICATIONS_ENABLED_KEY = 'push.notifications_enabled';

@Injectable({ providedIn: 'root' })
export class StorageService {

  private _preferencesService = inject(PreferencesService);

  async getToken(): Promise<string | null> {
    return await this._preferencesService.get<string>(TOKEN_KEY);
  }

  async setToken(token: string): Promise<void> {
    await this._preferencesService.set(TOKEN_KEY, token);
  }

  async clearToken(): Promise<void> {
    await this._preferencesService.remove(TOKEN_KEY);
  }

  async getOnboardingCompleted(): Promise<boolean | null> {
    return await this._preferencesService.get<boolean>(ONBOARDING_KEY);
  }

  async setOnboardingCompleted(completed: boolean): Promise<void> {
    await this._preferencesService.set(ONBOARDING_KEY, completed);
  }

  async getLocale(): Promise<string | null> {
    return await this._preferencesService.get<string>(LOCALE_KEY);
  }

  async setLocale(locale: string): Promise<void> {
    await this._preferencesService.set(LOCALE_KEY, locale);
  }

  async getPushNotificationsEnabled(): Promise<boolean | null> {
    return await this._preferencesService.get<boolean>(PUSH_NOTIFICATIONS_ENABLED_KEY);
  }

  async setPushNotificationsEnabled(enabled: boolean): Promise<void> {
    await this._preferencesService.set(PUSH_NOTIFICATIONS_ENABLED_KEY, enabled);
  }

  async getFcmToken(): Promise<string | null> {
    return await this._preferencesService.get<string>(FCM_TOKEN_KEY);
  }

  async setFcmToken(token: string): Promise<void> {
    await this._preferencesService.set(FCM_TOKEN_KEY, token);
  }

  async removeFcmToken(): Promise<void> {
    await this._preferencesService.remove(FCM_TOKEN_KEY);
  }

  async clearAll(): Promise<void> {
    await this._preferencesService.clear();
  }
}
